<template>
  <div class="custom-image">
      <div id="loader-container">
        <div id="loader"></div>  
      </div>
      <canvas id="canvas" width="655px" height="780px"></canvas>
      <canvas id="canvas-to-download"></canvas>
      <div id="measure"></div>
      <a id="download-full-resolution" href="#" download @click="lounchFireworks">تحميل</a>
      <Fireworks />
  </div>
</template>

<script>
/* eslint-disable */
import Fireworks from '@/components/Fireworks.vue';

export default {
  name: 'custom-image',
  data() {
    return {
      image: '2.png',
    }
  },
  components: {
    Fireworks
  },
  methods: {
    lounchFireworks: function() {
      EventBus.$emit('lounch')
    }
  },
  mounted() {

    let name = this.$route.params.name ? name = `${this.$route.params.gender}/ ${this.$route.params.name}` : 'زائر',
        title = this.$route.params.title ? title = this.$route.params.title : 'المسمى الوظيفي',
        component = this

    var canvas = document.getElementById('canvas'),
        context = canvas.getContext('2d'),
        canvasFullResolution = document.getElementById('canvas-to-download'),
        contextFullResolution = canvasFullResolution.getContext('2d');

    // this function fill an image on canvas
    function drawImage(image) {

      var ct = document.getElementById('measure');

      ct.appendChild(image);

      var wrh = image.width / image.height,
          newWidth = canvas.width,
          newHeight = newWidth / wrh,

          newFullResolutionWidth = image.width,
          newFullResolutionHeight = newFullResolutionWidth / wrh;

      canvasFullResolution.width = image.width;
      canvasFullResolution.height = image.height;

      if (newFullResolutionHeight > 1080) {

          newFullResolutionHeight = 1080;
          newFullResolutionWidth = newFullResolutionHeight * wrh;

          canvasFullResolution.width = newFullResolutionWidth;
          canvasFullResolution.height = newFullResolutionHeight;
      }

      if (newHeight > canvas.height) {
          newHeight = canvas.height;
          newWidth = newHeight * wrh;
      }

      let fontSize = `${canvas.height * 0.02}px`

      let color; //'#125E2B'

      if(component.image == '1.png' || component.image == '2.png') {
        color = '#fff'
      } else {
        color= '#125E2B'
      }

      ct.removeChild(image);

      var xOffset = newWidth < canvas.width ? ((canvas.width - newWidth) / 2) : 0,
          yOffset = newHeight < canvas.height ? ((canvas.height - newHeight) / 2) : 0;

      context.drawImage(image, xOffset, yOffset, newWidth , newHeight);
        
      contextFullResolution.drawImage(image, 0, 0, newFullResolutionWidth , newFullResolutionHeight)


      context.font = `${fontSize} Lemonada`;
      context.fillStyle = color;
      context.textAlign = 'center'
      context.textBaseline = 'bottom';

      contextFullResolution.fillStyle = color;
      contextFullResolution.textAlign = 'center'
      contextFullResolution.textBaseline = 'bottom';
      var metric = contextFullResolution.measureText(name);

      if(component.image == '1.png') {

        
        context.fillText(name, canvas.width / 2, newHeight - (newHeight * 0.1) )

        !title ? '' : context.fillText(title, canvas.width / 2, newHeight - (newHeight * 0.019) )
        contextFullResolution.font = `28px Lemonada`;
        contextFullResolution.fillText(name, canvasFullResolution.width / 2, newFullResolutionHeight - (newFullResolutionHeight * 0.195) )
        !title ? '' : contextFullResolution.fillText(title, canvasFullResolution.width / 2, newFullResolutionHeight - (newFullResolutionHeight * 0.115) )

      } else if(component.image == '2.png') {

        name = component.$route.params.name ? component.$route.params.name : 'زائر';

        fontSize = `${canvas.height * 0.027}px`

        context.font = `${fontSize} Lemonada`;
        context.fillText(name, canvas.width / 2, newHeight - (newHeight * 0.15) )
        contextFullResolution.font = `28px Lemonada`;
        contextFullResolution.fillText(name, canvasFullResolution.width / 2, newFullResolutionHeight - (newFullResolutionHeight * 0.245) )

      } else if (component.image == '4.png') {

        // context.fillText(name, canvas.width / 2, newHeight - (newHeight * 0.115) )
        // contextFullResolution.font = `50px Lemonada`;
        // contextFullResolution.fillText(name, canvasFullResolution.width / 2, newFullResolutionHeight - (newFullResolutionHeight * 0.205) )

      } else {

        // context.fillText(name, canvas.width / 2, newHeight - (newHeight * 0.11) )
        // contextFullResolution.font = `50px Lemonada`;
        // contextFullResolution.fillText(name, canvasFullResolution.width / 2, newFullResolutionHeight - (newFullResolutionHeight * 0.198) )

      }

    }

    var imageObj = new Image(),
        imageFullResolution = new Image();

    imageObj.src = `./img/${this.image}`;
    imageFullResolution.src = `./img/${this.image}`;

    function drawnFullResolution() {

      const prom = new Promise(function(resolve,reject){

       imageFullResolution.onload = function(){
           if(imageFullResolution.complete) {
             setTimeout(()=>{
               resolve();
             }, 1000)
           }
       };
      });
      return prom;
    }

    const loaderContainer = document.querySelector('#loader-container');

    drawnFullResolution().then(() => {
      
      const dataURL = canvasFullResolution.toDataURL("image/png"),
            div = document.querySelector('#fullsized_image_holder') ? document.querySelector('#fullsized_image_holder') : document.createElement('div'),
            img = document.querySelector('#fullsized_image_holder') ? document.querySelector('#fullsized_image_holder img') : document.createElement('img');

      div.setAttribute('id', 'fullsized_image_holder');

      div.appendChild(img);

      img.setAttribute('src', dataURL);

      document.querySelector('body').appendChild(div);

      const myDiv = document.querySelector('#fullsized_image_holder'),
            myImage = myDiv.children[0],
            downloadFullResolution = document.querySelector('#download-full-resolution');

        downloadFullResolution.href = myImage.src;
      })

      imageObj.onload = function () {
        
        drawImage(this)

        loaderContainer.style.display = "none"
    };

    // set this to false to maintain the canvas aspect ratio, or true otherwise
    var stretch_to_fit = false;

    function resize() {
        // aspect ratio
        var widthToHeight = canvas.width / canvas.height;
        var newWidthToHeight = widthToHeight;

        // cache the window dimensions (discount the border)
        var newWidth = window.innerWidth - 20,
            newHeight = window.innerHeight - 20;

        if (stretch_to_fit) {

            // overwrite the current canvas aspect ratio to fit the entire screen
            widthToHeight = window.innerWidth / window.innerHeight;

        } else {
            newWidthToHeight = newWidth / newHeight;
        }

        // scale the canvas
        if (newWidthToHeight > widthToHeight) {
            newWidth = newHeight * widthToHeight;
            canvas.height = newHeight;
            canvas.width = newWidth;
        } else {
            newHeight = newWidth / widthToHeight;
            canvas.width = newWidth;
            canvas.height = newHeight;
        }

    }

    // listen to resize events
    window.addEventListener('resize', function () {

      canvas.style.visibility = 'visible'

      // resizes the canvas (this will clear the canvas because the width and height parameters are changed).
      resize();

      // so, we need to redraw the image back on canvas
      drawImage(imageObj);

    }, false);

    window.onload = function () {

      resize();

      // resizes the canvas (this will clear the canvas because the width and height parameters are changed).
      resize();

      // so, we need to redraw the image back on canvas
      drawImage(imageObj);
    }

    // also resize the screen on orientation changes
    window.addEventListener('orientationchange', function () {
        resize();
        drawImage(imageObj);
    }, false);


    // first resize
    resize();

    const images = document.querySelectorAll('.toggle-images img');

    images.forEach(image => {
      image.addEventListener('click', () => {


        imageObj.src = `./img/${this.image}`;

        // resizes the canvas (this will clear the canvas because the width and height parameters are changed).
        resize();

        // so, we need to redraw the image back on canvas
        drawImage(imageObj);

      })
    })

    const a = this.$el.querySelector('a')

    setTimeout(() => {
      a.classList.add('active')
    }, 1000)
  }
}

</script>

<style lang="sass">

  .custom-image
    position: relative
    width: 100vw
    height: 100vh
    display: flex
    flex-direction: column
    overflow-y: scroll
    overflow-x: hidden

    #loader-container
      width: 70px
      height: 35px
      overflow: hidden
      position: absolute
      top: calc(50% - 17px)
      left: calc(50% - 35px)
      z-index: 5

      #loader
        width: 70px
        height: 70px
        border-style: solid
        border-top-color: #FFF
        border-right-color: #FFF
        border-left-color: transparent
        border-bottom-color: transparent
        border-radius: 50%
        box-sizing: border-box
        animation: rotate 3s ease-in-out infinite
        transform: rotate(-200deg)
      
      @keyframes rotate
        0% 
          border-width: 10px 
        25% 
          border-width: 3px 
        50% 
          transform: rotate(115deg) 
          border-width: 10px
        
        75% 
          border-width: 3px
        100% 
          border-width: 10px
    

    &::-webkit-scrollbar
        width: 3px

    /* Track */
    &::-webkit-scrollbar-track
        background: #f1f1f1
        border-radius: 5px

    /* Handle */
    &::-webkit-scrollbar-thumb
        background: #f39c12
        border-radius: 5px

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover
        background: #f39c12

    #canvas-to-download
      display: none

    #canvas
      position: absolute
      top: 50% 
      left: 50%
      transform: translate(-50%, -50%)

    a
      position: fixed
      bottom: 20px
      left: -200px
      background-image: url('../../public/img/launch.svg')
      background-repeat: no-repeat
      color: #fff
      font-size: 2em
      text-decoration: none
      padding: 140px 20px 0
      transition: left .7s cubic-bezier(0.175, 0.885, 0.32, 1.275)
      z-index: 2

      @media screen and (max-width: 475px)
        font-size: 1em
        padding: 90px 20px 0

      &.hide
        display: none

      &.active
        left: 20px
  #fullsized_image_holder
    width: 0
    height: 0
    overflow: hidden
</style>
